/**
 * LOGOI LAB - i18n Configuration
 * 
 * Auto-detects browser/device language.
 * Fallback: Spanish (es) — original language of the app.
 * Supported: es, en
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 * @framework Cadena Strategic Systems
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],

    // Browser language detection order:
    // 1. navigator.language (device/OS setting)
    // 2. navigator.languages[0]
    // 3. htmlTag lang attribute
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'logos-lang',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Only match base language (e.g. "en-US" → "en", "es-MX" → "es")
    load: 'languageOnly',
  });

export default i18n;
